import { de, enUS, fr, pl } from 'date-fns/locale';

const localeMap: Record<string, Locale> = {
  en: enUS,
  'en-US': enUS,
  fr,
  'fr-FR': fr,
  de,
  'de-DE': de,
  pl,
  'pl-PL': pl,
};

export const getDateFnsLocale = (locale?: string) => {
  if (!locale) return enUS;
  return localeMap[locale] || localeMap[locale.split('-')[0]] || enUS;
};
